import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyList } from '../propertyEndpoints'
import type { PropertiesApiParams } from '../../types/propertyTypes'

export function usePropertyListQuery(filters: MaybeRefOrGetter<PropertiesApiParams>) {
  return useQuery({
    queryKey: () => propertyKeys.list(toValue(filters)),
    queryFn: () => getPropertyList(toValue(filters)),
  })
}
